import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import CompanyRoute from "./components/CompanyRoute";
import Landing from "./pages/Landing";
import Register from "./pages/Auth/Register";
import Login from "./pages/Auth/Login";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import VerifyEmail from "./pages/Auth/VerifyEmail";
import OAuthCallback from "./pages/Auth/OAuthCallback";
import Dashboard from "./pages/User/Dashboard";
import Profile from "./pages/User/Profile";
import Credits from "./pages/User/Credits";
import Referrals from "./pages/User/Referrals";
import ResumeBuilder from "./pages/User/ResumeBuilder";
import ATSAnalyzer from "./pages/User/ATSAnalyzer";
import JobMatcher from "./pages/User/JobMatcher";
import Jobs from "./pages/User/Jobs";
import JobDetails from "./pages/User/JobDetails";
import Resumes from "./pages/User/Resumes";
import ResumePreviewPage from "./pages/User/ResumePreviewPage";
import CompanyLogin from "./pages/Company/CompanyLogin";
import CompanyRegister from "./pages/Company/CompanyRegister";
import CompanyDashboard from "./pages/Company/CompanyDashboard";
import Candidates from "./pages/Company/Candidates";
import UploadResumes from "./pages/Company/UploadResumes";
import CandidateDetails from "./pages/Company/CandidateDetails";
import MatchCandidates from "./pages/Company/MatchCandidates";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
            <Route
              path="/resume/:shareableLink"
              element={<div>Public Resume</div>}
            />

            {/* User protected */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resumes"
              element={
                <ProtectedRoute>
                  <Resumes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resumes/new"
              element={
                <ProtectedRoute>
                  <ResumeBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resumes/:id/edit"
              element={
                <ProtectedRoute>
                  <ResumeBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resumes/:id/preview"
              element={
                <ProtectedRoute>
                  <ResumePreviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ats-analyzer"
              element={
                <ProtectedRoute>
                  <ATSAnalyzer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/job-matcher"
              element={
                <ProtectedRoute>
                  <JobMatcher />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <Jobs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs/:id"
              element={
                <ProtectedRoute>
                  <JobDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/credits"
              element={
                <ProtectedRoute>
                  <Credits />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referrals"
              element={
                <ProtectedRoute>
                  <Referrals />
                </ProtectedRoute>
              }
            />

            {/* Company routes */}
            <Route path="/company/login" element={<CompanyLogin />} />
            <Route path="/company/register" element={<CompanyRegister />} />
            <Route
              path="/company/dashboard"
              element={
                <CompanyRoute>
                  <CompanyDashboard />
                </CompanyRoute>
              }
            />
            <Route
              path="/company/jobs"
              element={
                <CompanyRoute>
                  <div>Manage Jobs</div>
                </CompanyRoute>
              }
            />
            <Route
              path="/company/jobs/new"
              element={
                <CompanyRoute>
                  <div>Create Job</div>
                </CompanyRoute>
              }
            />
            <Route
              path="/company/resumes"
              element={
                <CompanyRoute>
                  <Candidates />
                </CompanyRoute>
              }
            />
            <Route
              path="/company/resumes/upload"
              element={
                <CompanyRoute>
                  <UploadResumes />
                </CompanyRoute>
              }
            />
            <Route
              path="/company/candidates/:id"
              element={
                <CompanyRoute>
                  <CandidateDetails />
                </CompanyRoute>
              }
            />
            <Route
              path="/company/match"
              element={
                <CompanyRoute>
                  <MatchCandidates />
                </CompanyRoute>
              }
            />
            <Route
              path="/company/analytics"
              element={
                <CompanyRoute>
                  <div>Analytics</div>
                </CompanyRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
